(function () {
  'use strict';

  if (window.ProductGallery2026) return;

  var instances = new Map();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function toBoolean(value) {
    return value === true || value === 'true';
  }

  function mediaLoader() {
    return window.ProductMedia2026;
  }

  function loadImage(img) {
    var loader = mediaLoader();
    if (loader && typeof loader.load === 'function') loader.load(img);
  }

  function loadAround(swiper) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return;
    var active = swiper.slides[swiper.activeIndex];
    var count = swiper.slides.length;
    var previous = swiper.slides[swiper.params.loop ? (swiper.activeIndex + count - 1) % count : swiper.activeIndex - 1];
    var next = swiper.slides[swiper.params.loop ? (swiper.activeIndex + 1) % count : swiper.activeIndex + 1];
    [active, previous, next].forEach(function (slide) {
      if (!slide) return;
      slide.querySelectorAll('img.progressive-img').forEach(loadImage);
    });
  }

  function bindImagePress(root, state) {
    var pointer = null;
    var animations = [];
    var targets = [];
    var releaseTimer = null;
    var started = 0;
    var generation = 0;
    var options = { signal: state.controller.signal };

    function clear() {
      generation += 1;
      clearTimeout(releaseTimer);
      animations.forEach(function (animation) { animation.cancel(); });
      animations = [];
      targets = [];
      pointer = null;
      delete root.dataset.galleryPressActive;
    }
    root.addEventListener('pointerdown', function (event) {
      clear();
      state.dragged = false;
      var trigger = event.target.closest('[data-gallery-open]');
      if (!trigger || trigger.closest('.lightbox-modal') || event.button !== 0 || !event.isPrimary) return;
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
      // Track drags even with motion disabled. A swipe is never a request to zoom.
      if (root.dataset.imagePress !== 'squeeze' || reducedMotion.matches) return;
      var img = trigger.matches('img') ? trigger : trigger.querySelector('img');
      var artwork = img && (img.closest('[data-gallery-artwork]') || img);
      if (!artwork || typeof artwork.animate !== 'function') return;
      targets = [artwork];
      root.dataset.galleryPressActive = 'true';
      started = performance.now();
      animations = targets.map(function (image) {
        return image.animate([{ scale: '1 1' }, { scale: '.84 1.025' }], {
          duration: 160, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'forwards'
        });
      });
    }, options);
    document.addEventListener('pointermove', function (event) {
      if (!pointer || pointer.id !== event.pointerId) return;
      if (Math.hypot(event.clientX - pointer.x, event.clientY - pointer.y) > 10) {
        state.dragged = true;
        clear();
      }
    }, options);
    document.addEventListener('pointerup', function (event) {
      if (!pointer || pointer.id !== event.pointerId) return;
      pointer = null;
      if (!targets.length) return;
      // Only the visual finishes its press; opening the viewer remains immediate.
      var releasedGeneration = generation;
      releaseTimer = setTimeout(function () {
        var scales = targets.map(function (image) { return getComputedStyle(image).scale; });
        animations.forEach(function (animation) { animation.cancel(); });
        animations = targets.map(function (image, index) {
          return image.animate([{ scale: scales[index] }, { scale: '1 1' }], {
            duration: 440, easing: 'cubic-bezier(.22, 1, .36, 1)'
          });
        });
        Promise.all(animations.map(function (animation) { return animation.finished.catch(function () {}); })).then(function () {
          if (releasedGeneration === generation) delete root.dataset.galleryPressActive;
        });
      }, Math.max(0, 160 - (performance.now() - started)));
    }, options);
    document.addEventListener('pointercancel', function (event) {
      if (pointer?.id === event.pointerId) { state.dragged = true; clear(); }
    }, options);
    root.addEventListener('dragstart', function () { state.dragged = true; clear(); }, options);
    window.addEventListener('blur', clear, options);
    reducedMotion.addEventListener('change', clear, options);
    state.cleanups.push(clear);
  }

  function bindZoom(root, slide, state) {
    if (!slide || !window.ProductZoom2026) return;
    slide.querySelectorAll('.zoom-image').forEach(function (img) {
      if (state.zooms.has(img)) return;
      var zoom = window.ProductZoom2026.mount(root, img);
      if (!zoom) return;
      state.zooms.set(img, zoom);
      state.cleanups.push(zoom.destroy);
    });
  }

  function initMainSlider(root, mainElement, state) {
    function thumbGap() {
      var element = root.querySelector('.thumb-slider');
      var computed = element && parseFloat(getComputedStyle(element).columnGap);
      return Number.isFinite(computed) ? computed : Number(root.dataset.galleryThumbGap) || 0;
    }
    var gap = thumbGap();
    var loop = toBoolean(root.dataset.galleryLoop) && mainElement.querySelectorAll('.swiper-slide').length > 1;

    var verticalElement = root.querySelector('.thumb-slider-vertical');
    var horizontalElement = root.querySelector('.thumb-slider-horizontal');
    var verticalThumbs = verticalElement ? new Swiper(verticalElement, {
      direction: 'vertical',
      spaceBetween: gap,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      allowTouchMove: true,
      navigation: {
        nextEl: root.querySelector('.thumb-vertical-button-next'),
        prevEl: root.querySelector('.thumb-vertical-button-prev')
      }
    }) : null;
    var horizontalThumbs = horizontalElement ? new Swiper(horizontalElement, {
      direction: 'horizontal',
      spaceBetween: gap,
      slidesPerView: 'auto',
      watchSlidesProgress: true,
      allowTouchMove: true,
      navigation: {
        nextEl: root.querySelector('.thumb-horizontal-button-next'),
        prevEl: root.querySelector('.thumb-horizontal-button-prev')
      }
    }) : null;

    function updateThumbs(swiper) {
      var index = swiper.realIndex;
      var imageHadFocus = mainElement.contains(document.activeElement) && document.activeElement.matches('[data-gallery-open]');
      mainElement.querySelectorAll('[data-gallery-open]').forEach(function (image) {
        var artwork = image.matches('img') ? image : image.querySelector('img');
        var active = Number(artwork?.dataset.index) === index;
        image.tabIndex = active ? 0 : -1;
        image.setAttribute('aria-hidden', String(!active));
      });
      if (imageHadFocus) mainElement.querySelector('[data-gallery-open][tabindex="0"]')?.focus({ preventScroll: true });
      [verticalElement, horizontalElement].forEach(function (element) {
        if (!element) return;
        element.querySelectorAll('.swiper-slide').forEach(function (slide, slideIndex) {
          slide.classList.toggle('swiper-slide-thumb-active', slideIndex === index);
          slide.querySelector('button')?.setAttribute('aria-current', String(slideIndex === index));
        });
      });
      [verticalThumbs, horizontalThumbs].forEach(function (thumbs) {
        if (!thumbs) return;
        var nextGap = thumbGap();
        if (thumbs.params.spaceBetween !== nextGap) {
          thumbs.params.spaceBetween = nextGap;
          thumbs.update();
        }
        thumbs.slideTo(index);
      });
      root.querySelectorAll('.product-thumbnails .thumbnail').forEach(function (thumb, thumbIndex) {
        thumb.classList.toggle('active', thumbIndex === index);
        thumb.setAttribute('aria-current', String(thumbIndex === index));
      });
      loadAround(swiper);
      state.zooms.forEach(function (zoom) { zoom.hide(); });
      root.dispatchEvent(new CustomEvent('product-gallery:change'));
      bindZoom(root, swiper.slides[swiper.activeIndex], state);
    }

    var selectedMediaId = root.dataset.selectedMediaId || root.querySelector('[data-selected-media-id]')?.dataset.selectedMediaId;
    var firstIndex = Array.from(mainElement.querySelectorAll('img[data-media-id]')).findIndex(function (image) {
      return image.dataset.mediaId === selectedMediaId;
    });
    var mainSwiper = new Swiper(mainElement, {
      initialSlide: Math.max(0, firstIndex),
      slidesPerView: 1,
      spaceBetween: 10,
      speed: reducedMotion.matches ? 0 : 280,
      loop: loop,
      navigation: {
        nextEl: root.querySelector('.main-button-next'),
        prevEl: root.querySelector('.main-button-prev')
      },
      on: {
        init: function () { updateThumbs(this); },
        slideChange: function () { updateThumbs(this); },
        resize: function () { updateThumbs(this); }
      }
    });

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-gallery-select]');
      if (!button || (event.detail > 0 && state.dragged)) return;
      var index = Number(button.dataset.gallerySelect);
      if (mainSwiper.params.loop) mainSwiper.slideToLoop(index);
      else mainSwiper.slideTo(index);
    }, { signal: state.controller.signal });
    mainElement.addEventListener('keydown', function (event) {
      if (!event.target.matches('[data-gallery-open]') || event.altKey || event.ctrlKey || event.metaKey) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'ArrowLeft') mainSwiper.slidePrev();
      else if (event.key === 'ArrowRight') mainSwiper.slideNext();
      else {
        var target = event.key === 'Home' ? 0 : mainElement.querySelectorAll('[data-gallery-open]').length - 1;
        if (mainSwiper.params.loop) mainSwiper.slideToLoop(target);
        else mainSwiper.slideTo(target);
      }
      mainElement.querySelector('[data-gallery-open][tabindex="0"]')?.focus({ preventScroll: true });
    }, { signal: state.controller.signal });
    state.cleanups.push(function () {
      [mainSwiper, verticalThumbs, horizontalThumbs].forEach(function (swiper) {
        if (swiper) swiper.destroy(true, true);
      });
    });

    return mainSwiper;
  }

  function init(root) {
    if (!root || root.dataset.productGalleryInitialized === 'true') return;
    if (typeof window.Swiper !== 'function') return;

    root.dataset.productGalleryInitialized = 'true';
    var state = { controller: new AbortController(), cleanups: [], zooms: new Map(), dragged: false };
    instances.set(root, state);
    bindImagePress(root, state);

    // The stacked layout has a lightbox but no carousel, so the two are independent.
    var mainElement = root.querySelector('.main-slider');
    root.dataset.galleryImageCount = String(root.querySelectorAll('.lightbox-main .swiper-slide').length);
    var mainSwiper = mainElement ? initMainSlider(root, mainElement, state) : null;

    if (!mainSwiper) {
      bindZoom(root, root.querySelector('.lightbox-gallery'), state);
      var selectedMediaId = root.dataset.selectedMediaId || root.querySelector('[data-selected-media-id]')?.dataset.selectedMediaId;
      if (selectedMediaId) document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { sectionId: root.dataset.sectionId, mediaId: selectedMediaId }
      }));
    }

    if (window.ProductLightbox2026) state.cleanups.push(window.ProductLightbox2026.mount(root, mainSwiper, state));
  }

  function initAll(scope) {
    if (scope?.matches?.('[data-product-section]')) init(scope);
    (scope || document).querySelectorAll('[data-product-section]').forEach(init);
  }

  function destroy(root) {
    var state = instances.get(root);
    if (!state) return;
    state.controller.abort();
    state.cleanups.reverse().forEach(function (cleanup) { cleanup(); });
    delete root.dataset.productGalleryInitialized;
    delete root.dataset.galleryImageCount;
    instances.delete(root);
  }
  window.ProductGallery2026 = { init: init, initAll: initAll, destroy: destroy };
  document.addEventListener('product-zoom:ready', function () {
    instances.forEach(function (state, root) {
      bindZoom(root, root.querySelector('.main-slider .swiper-slide-active') || root.querySelector('.lightbox-gallery'), state);
    });
  });
  reducedMotion.addEventListener('change', function () {
    instances.forEach(function (_, root) {
      root.querySelectorAll('.swiper').forEach(function (element) {
        if (element.swiper) element.swiper.params.speed = reducedMotion.matches ? 0 : (element.matches('.lightbox-main') ? 240 : 280);
      });
    });
  });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (_, root) { if (root === event.target || event.target.contains(root)) destroy(root); });
  });
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
